import { init as initSliderBrands } from './sliders/home-slider-brands';
import { init as initSliderInformations } from './sliders/home-slider-informations';
import { init as initSliderOpeco } from './sliders/home-slider-opeco';
import { init as initSliderServicesHeader } from './sliders/home-slider-services-header';

export function init() {
  // Init Home Slider -- OPECO
  if($('.dkt-home-slider').is(':visible') && $('.dkt-home-slider__content > *').length){
    initSliderOpeco({
      container: cube.$('.dkt-home-slider'),
      autoplay: true,
    });
  }

  // Init all others HP Sliders
  initSliderBrands();
  initSliderInformations();
  initSliderServicesHeader();
}



// WEBPACK FOOTER //
// ./src/homepage/homepage-sliders.entry.js